/**
 * Supported locales for YADA.
 *
 * Add new locales here as they are translated. The type system will
 * automatically enforce that all locale files exist when the i18n instance
 * is initialised.
 */
export type SupportedLocale = 'en' | 'pl' | 'es';

/**
 * Namespace names correspond directly to JSON files under each locale
 * directory: `packages/i18n/src/locales/<locale>/<namespace>.json`.
 *
 * Extend this union when you add a new namespace file.
 */
export type I18nNamespace =
  | 'common'
  | 'auth'
  | 'settings'
  | 'habits'
  | 'chat'
  | 'docs'
  | 'calendar'
  | 'meal-planner'
  | 'groups'
  | 'admin'
  | 'devtools'
  | 'emoji'
  | 'community-votes'
  | 'content-distribution'
  | 'events'
  | 'trips'
  | 'training'
  | 'finance';

/** Language metadata used in UI selectors. */
export interface LanguageOption {
  /** BCP-47 language tag, matches SupportedLocale */
  code: SupportedLocale;
  /** Native name of the language */
  nativeName: string;
  /** Name in English */
  englishName: string;
  /** Unicode flag emoji */
  flag: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', nativeName: 'English', englishName: 'English', flag: '🇬🇧' },
  { code: 'pl', nativeName: 'Polski', englishName: 'Polish', flag: '🇵🇱' },
  { code: 'es', nativeName: 'Español', englishName: 'Spanish', flag: '🇪🇸' },
];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** localStorage key used to persist the user's language preference. */
export const LOCALE_STORAGE_KEY = 'yada:locale';
